@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.locationpoint

import com.narbase.letsgo.web.dto.favoritepoints.FavoritePointDto
import com.narbase.letsgo.web.dto.pointsOfIntrest.PointOfInterestDto

class LocationPointDto (
    val lat: Double,
    val lng: Double,
    val address: String? = null,
    val name: String? = null,
    val nameFr: String? = null,
    val pointOfInterestDto: PointOfInterestDto? = null,
    val favoritePointDto: FavoritePointDto? = null,
    val isCurrentLocation: Boolean = false,
    val isNear: Boolean = false,
    val relevanceScore: Double? = null,
) {
    fun sameAs(other: LocationPointDto): Boolean {
        return (this.lat == other.lat) && (this.lng == other.lng)
    }

    fun copy(
        lat: Double? = null,
        lng: Double? = null,
        address: String? = null,
        name: String? = null,
        pointOfInterestDto: PointOfInterestDto? = null,
        favoritePointDto: FavoritePointDto? = null
    ) : LocationPointDto =
        LocationPointDto(
            lat = lat ?: this.lat,
            lng = lng ?: this.lng,
            address = address ?: this.address,
            name = name ?: this.name,
            nameFr = nameFr ?: this.nameFr,
            pointOfInterestDto = pointOfInterestDto ?: this.pointOfInterestDto,
            favoritePointDto = favoritePointDto ?: this.favoritePointDto,
        )
}
